import { Filter, type SelectItem } from '@vrplatform/components';
import type { party_enum } from '@vrplatform/graphql';
import type { Maybe } from '@vrplatform/utils';
import type { BaseCustomFilterProps } from './_types';

interface Props extends BaseCustomFilterProps {
  party: Maybe<party_enum>;
  setParty: (party: party_enum | null) => void;
}

const OPTIONS: SelectItem<party_enum>[] = [
  {
    value: 'owners',
    label: 'Owners',
  },
  {
    value: 'manager',
    label: 'Manager',
  },
];

export const PartyFilter = ({ party, setParty, label = 'Party' }: Props) => {
  const value = OPTIONS.find((option) => option.value === party) ?? null;

  return (
    <Filter.Select
      type="single"
      label={label}
      value={value}
      data={{
        options: OPTIONS,
      }}
      setValue={(value) => setParty(value?.value || null)}
      hideSearch
    />
  );
};
